import React, { Component } from 'react';
import parse from 'html-react-parser';
import Button from './Button';
import { withTranslation } from 'react-i18next';
import { withSuspense } from '../../../common/utils';

class GeneralMessages extends Component {
    render() {
        const { t } = this.props
        const { titleOne, titleTwo, subTitle, titleLinkOne, titleLinkTwo, titleLinkThree, descriptionOne, linkDescOne, linkDescTwo, linkDescThree, descriptionTwo } = this.props
        return (
            <main class="container" role="main" id="content">
                <div className="row">
                    <div className="col-lg-12">
                        <div id="id-error-message" className="col status-page_description">
                            {titleOne ? parse(titleOne) : <></>}
                            {titleTwo ? parse(titleTwo) : <></>}
                            {descriptionOne ? parse(descriptionOne) : <></>}
                            {descriptionTwo ? parse(descriptionTwo) : <></>}<br /><br /><br />
                            <u> {subTitle ? parse(subTitle) : <></>}</u>
                            {titleLinkOne ? parse(titleLinkOne) : <></>}
                            {linkDescOne ? <p>{linkDescOne}</p> : <></>}
                            {titleLinkTwo ? parse(titleLinkTwo) : <></>}
                            {linkDescTwo ? <p>{linkDescTwo}</p> : <></>}
                            {titleLinkThree ? parse(titleLinkThree) : <></>}
                            {linkDescThree ? <p>{linkDescThree}</p> : <></>}
                        </div>
                    </div>
                </div>
            </main>
        );
    }
}

export default withSuspense()(withTranslation()(GeneralMessages));